import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {ThemeService} from '../theme.service';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit {

    public step = 1;
    public hasVideoPermission = false;
    public hasVideoPermissionError = false;
    public hasAudioPermission = false;
    public hasAudioPermissionError = false;

    public SpeakerSetEnabled = ('sinkId' in HTMLMediaElement.prototype);

    public loading = false;
    public Speakers$ = new BehaviorSubject<MediaDeviceInfo[]>([])
    public Microphones$ = new BehaviorSubject<MediaDeviceInfo[]>([])
    public Cameras$ = new BehaviorSubject<MediaDeviceInfo[]>([])

    public PermissionsForm = this.fb.group({
        Permission: [false, Validators.requiredTrue]
    }) as FormGroupTyped<{
        Permission: boolean;
    }>;

    public CameraForm = this.fb.group({
        Camera: ['', Validators.required]
    }) as FormGroupTyped<{
        Camera: string;
    }>;

    public MicrophoneForm = this.fb.group({
        Microphone: ['', Validators.required]
    }) as FormGroupTyped<{
        Microphone: string;
    }>;

    public SpeakersForm = this.fb.group({
        Speaker: ['', Validators.required]
    }) as FormGroupTyped<{
        Speaker: string;
    }>;

    constructor(
        protected router: Router,
        protected fb: FormBuilder,
        public Theme: ThemeService
    ) {
    }

    ngOnInit(): void {
    }

    public requestPermission() {
        this.loading = true;
        navigator.mediaDevices.getUserMedia({
            audio: true,
            video: {
                facingMode: 'environment'
            }
        }).then(m => {
            m.getTracks().forEach(t => t.stop());
            navigator.mediaDevices.enumerateDevices()
                .then(devices => {
                    const speakers = devices.filter(d => d.kind == 'audiooutput')
                    const microphones = devices.filter(d => d.kind == 'audioinput')
                    const cameras = devices.filter(d => d.kind == 'videoinput')

                    this.Speakers$.next(speakers.filter(s => s.deviceId.length > 16));
                    this.Microphones$.next(microphones);
                    this.Cameras$.next(cameras);

                    let videoTrack = m.getTracks().find(t => t.kind == 'video');
                    let cameraId = videoTrack.getSettings().deviceId;

                    let foundComSpeaker = false;
                    let foundDefaultSpeaker = false;
                    let speakerSetSame = '';

                    this.PermissionsForm.controls.Permission.setValue(true);
                    this.loading = false;

                    speakers.forEach(s => {
                        if (s.deviceId == 'communications') {
                            foundComSpeaker = true;
                            speakerSetSame = s.label;
                        }
                    });
                    if (!foundComSpeaker) {
                        speakers.forEach(s => {
                            if (s.deviceId == 'default') {
                                foundDefaultSpeaker = true;
                                speakerSetSame = s.label;
                            }
                        });
                    }
                    if (speakers.length != 0) {
                        let found = false;
                        let searchres = /^[A-z]+ - (.*)$/.exec(speakerSetSame)

                        if (searchres?.length >= 1) {
                            let search = searchres[1];

                            speakers.forEach(s => {
                                if (s.label.includes(search)) {
                                    found = true;
                                    this.SpeakersForm.controls.Speaker.setValue(s.deviceId);
                                }
                            });
                        }

                        if (!found) {
                            if (speakers?.length > 0) {
                                this.SpeakersForm.controls.Speaker.setValue(speakers[0].deviceId);
                            }
                        }
                    }

                    let foundComMicrophone = false;
                    let foundDefaultMicrophone = false;
                    let microphoneSetSame = '';
                    microphones.forEach(m => {
                        if (m.deviceId == 'communications') {
                            foundComMicrophone = true;
                            microphoneSetSame = m.label;
                            this.MicrophoneForm.controls.Microphone.setValue(m.deviceId);
                        }
                    });
                    if (!foundComMicrophone) {
                        microphones.forEach(m => {
                            if (m.deviceId == 'default') {
                                foundDefaultMicrophone = true;
                                microphoneSetSame = m.label;
                                this.MicrophoneForm.controls.Microphone.setValue(m.deviceId);
                            }
                        });
                    }
                    if (!foundComMicrophone && !foundDefaultMicrophone && microphones.length != 0) {
                        let found = false;
                        let searchres = /^[A-z]+ - (.*)$/.exec(microphoneSetSame)

                        if (searchres?.length >= 1) {
                            let search = searchres[1];
                            microphones.forEach(s => {
                                if (s.label.includes(search)) {
                                    found = true;
                                    this.MicrophoneForm.controls.Microphone.setValue(s.deviceId);
                                }
                            });
                        }

                        if (!found) {
                            if (microphones?.length > 0) {
                                this.MicrophoneForm.controls.Microphone.setValue(microphones[0].deviceId);
                            }
                        }
                    }

                    this.CameraForm.controls.Camera.setValue(cameraId);
                })
                .catch(e => {
                    console.error(e)
                    alert('Leider ist ein Fehler aufgetreten');
                });
        })
        .catch(e => {
            console.error(e)
            alert('Leider ist ein Fehler');
        });
    }

    public Finish() {
        localStorage.setItem('permissionOk', JSON.stringify(true));
        localStorage.setItem('speakerSettings', this.SpeakersForm.controls.Speaker.value);
        localStorage.setItem('microphoneSetting', this.MicrophoneForm.controls.Microphone.value);
        localStorage.setItem('cameraSetting', this.CameraForm.controls.Camera.value);
        this.router.navigate(['/video', localStorage.getItem('permissionReturn')])
    }

    public requestAudioPermission() {
        navigator.mediaDevices.getUserMedia({audio: true, video: false}).then(m => {
            m.getTracks().forEach(t => t.stop());
            if (navigator.permissions !== undefined) {
                navigator.permissions.query({
                    name: 'microphone'
                }).then(status => {
                    if (status.state == 'granted') {
                        this.hasAudioPermission = true
                    } else {
                        this.hasAudioPermissionError = true;
                    }
                });
            } else {
                this.hasAudioPermission = true;
            }

        }, () => {
            if (navigator.permissions !== undefined) {
                navigator.permissions.query({
                    name: 'microphone'
                }).then(status => {
                    if (status.state == 'granted') {
                        this.hasAudioPermission = true
                    } else {
                        this.hasAudioPermissionError = true;
                    }
                });
            } else {
                this.hasAudioPermissionError = true;
            }
        });
    }
}

@Component({
    selector: 'app-clear',
    template: '<h1>clear</h1>',
})
export class ClearComponent implements OnInit {
    constructor(
        protected router: Router
    ){}

    ngOnInit(): void {
        localStorage.clear();
        this.router.navigate(['/fine']);
    }
}
